<div *ngIf="isError" class="loader__container">
  <h3>We're sorry. Something went wrong. </h3>
</div>

<div *ngIf="loading && !isError" class="loading-overlay">
  <div class="loader__container">
    <div class="loader"></div>
  </div>
</div>

<div class="full-container" *ngIf="!loading && !isError">
    <app-digitization-top-nav
        [document]="state?.reviewQueueItem"
        [documentFile]="state?.documentFile"
        [actionsDisabledForReSpreadLock]="reSpreadInProgress"
        [hasRedesignedShortcuts]="true"
        (saveMethod)="saveAndStay()"
        (nextMethod)="handleCompleteClick()"
    >
        <div header-action *ngIf="hasTranslations()" class="toggler translate-toggle">
            <label>Translate to English</label>
            <i class="fas"
               [ngClass]="{'fa-toggle-off': viewInNativeLanguage, 'fa-toggle-on': !viewInNativeLanguage}"
               (click)="swapLanguage()"></i>
        </div>
        <div class="btn-group undo-redo-button undo-button">
          <button class="btn btn-link undo-redo-link" (click)="undo()" [disabled]="noMoreUndos || reSpreadInProgress" title="Undo"><i *ngIf="!undoButtonLoading" class="fa fa-rotate-left fa-lg"></i><div *ngIf="undoButtonLoading" class="loader button-loader"></div></button>
        </div>
        <div class="btn-group undo-redo-button">
          <button class="btn btn-link undo-redo-link" (click)="redo()" [disabled]="noMoreRedos || reSpreadInProgress" title="Redo"><i *ngIf="!redoButtonLoading" class="fa fa-rotate-right fa-lg"></i><div *ngIf="redoButtonLoading" class="loader button-loader"></div></button>
        </div>
        <div *ngIf="enableAccessToDoc" class="template-toggle">
            <p>Show Document</p>
            <i class="fas fa-toggle-off" (click)="toggleDocumentExplorer($event)"
               [ngClass]="{'fa-toggle-off': !documentSidebarIsOpen, 'fa-toggle-on': documentSidebarIsOpen, 'disabled': reSpreadInProgress}"></i>
        </div>

        <div *ngIf="isDASStatement && state.templateHasSubmissionRules" class="template-toggle">
            <p>Show Submission Rules</p>
            <i class="fas fa-toggle-off" (click)="toggleSubmissionRulesSidebar($event)"
               [ngClass]="{'fa-toggle-off': !submissionRulesSidebarIsOpen, 'fa-toggle-on': submissionRulesSidebarIsOpen}"></i>
        </div>

        <div *ngIf="!isVendorData">
            <button class="btn btn-empty-primary" (click)="downloadFile()">
                <i class="fas fa-download"></i>Download
            </button>
        </div>
        <div *ngIf="!isVendorData">
            <a (click)="reAutonormDocument()" class="link-primary" [ngClass]="{'disabled': reSpreadInProgress}"
               title="Resets all items back to original system mappings. Overrides any mappings changed by the user."><i class="fa fa-rotate"></i>Reset mappings</a>
        </div>

        <div>
            <a #filterPeriodsTrigger (click)="openPreviousPeriodsFilterPanel()" class="link-primary" title="Filter previous periods">
                <i class="fa fa-filter filter-icon"></i>Filter Periods
            </a>
        </div>
        <div *ngIf="canClearPreviousPeriodFilters">
            <a (click)="clearPreviousPeriodFilters()" class="link-primary" title="Reset to default reference period">
                <i class="fa fa-xmark clear-filters-icon"></i>Clear Filters
            </a>
        </div>

        <div class="rounding">
          <p>Displayed Rounded to: {{getDisplayRounding()}}</p>
          <i class="fa-solid fa-circle-info"
              title="The values shown are rounded for clarity. If you selected to multiply by millions in the previous step, the numbers here will be rounded to millions to keep them manageable. In the Financial Summary, the numbers will reflect the multiplied value.">
          </i>
        </div>
    </app-digitization-top-nav>

  <ng-container *ngIf="reSpreadInProgress; else mainPageContent">
      <app-template-re-spread-loading-view></app-template-re-spread-loading-view>
  </ng-container>
  <ng-template #mainPageContent>
  <div
    class="context-menu-backdrop"
    *ngIf="contextMenuMode"
    (click)="dismissContextMenu($event)"
    (contextmenu)="dismissContextMenu($event)"
  ></div>
  <ul class="dropdown-menu" [class.dropdown-menu--source-table]="contextMenuMode === 'sourceTableMenu'" [ngStyle]="contextMenuStyle">
    <li *ngIf="contextMenuMode === 'sourceTableMenu'" class="source-table-menu">
      <div class="menu-columns">
        <div class="menu-column menu-column--row">
          <div class="menu-col-heading">Row Level Actions</div>
          <div class="menu-item" [class.disabled]="!viewInNativeLanguage" (click)="!viewInNativeLanguage || cutSelected()">
            <i class="fa-solid fa-scissors"></i><span>Cut Row</span>
          </div>
          <div class="menu-item" [class.disabled]="!viewInNativeLanguage" (click)="!viewInNativeLanguage || copySelected()">
            <i class="fa-solid fa-copy"></i><span>Copy Row</span>
          </div>
          <div class="menu-item" [class.disabled]="!viewInNativeLanguage" (click)="!viewInNativeLanguage || pasteSelected()">
            <i class="fa-solid fa-paste"></i><span>Paste Row</span>
          </div>
          <div class="menu-divider"></div>
          <div class="menu-item" (click)="deleteRowAtIdx(contextMenuRowIndex)">
            <i class="fa-solid fa-trash-can"></i><span>Delete Row</span>
          </div>
          <div class="menu-item" (click)="addRowAtIdx(contextMenuRowIndex)">
            <i class="fa-solid fa-plus"></i><span>Add Row Above</span>
          </div>
          <div class="menu-item" (click)="addRowAtIdx(contextMenuRowIndex + 1)">
            <i class="fa-solid fa-plus"></i><span>Add Row Below</span>
          </div>
          <div class="menu-divider"></div>
          <div class="menu-item" *ngIf="contextMenuRow.categorizedTo && contextMenuRow.itemClass!=='supplementalItem'" (click)="uncategorizeSelectedRows()">
            <i class="fa-solid fa-rotate-left"></i><span>Uncategorize Row</span>
          </div>
          <div class="menu-item" *ngIf="canCategorize && !contextMenuRow.header" (click)="invertSelectedRows()">
            <i class="fa-solid fa-plus-minus"></i><span>Invert Row Values</span>
          </div>
          <div class="menu-item" *ngIf="!contextMenuRow.header" (click)="addAdjustmentRow(contextMenuRowIndex, contextMenuRow)">
            <i class="fa-solid fa-file-lines"></i><span>Add Adjustment Row</span>
          </div>
        </div>
        <div class="menu-column menu-column--cell" *ngIf="!contextMenuRow.header">
          <div class="menu-col-heading">Cell Level Actions</div>
          <ng-container *ngIf="!state.isDerivedOffsetRow(contextMenuRow)">
            <div class="menu-item" *ngIf="contextMenuIsLabelCell"
                 [class.disabled]="contextMenuRow.itemClass === 'supplementalItem'"
                 (click)="contextMenuRow.itemClass === 'supplementalItem' || editSourceLabelAndStopEvent($event, contextMenuRowIndex, contextMenuRow)">
              <i class="fa-solid fa-pencil"></i><span>Edit Cell</span>
            </div>
            <div class="menu-item" *ngIf="!contextMenuIsLabelCell" (click)="editCellAndStopEvent($event, contextMenuRow, contextMenuObjectIndex)">
              <i class="fa-solid fa-pencil"></i><span>Edit Cell</span>
            </div>
            <ng-container *ngIf="showSourceEnabledInContextMenu && contextMenuRow.itemClass!=='supplementalItem'">
              <div class="menu-item" *ngIf="contextMenuIsLabelCell" (click)="showSourceForRow($event, contextMenuRow)">
                <i class="fa-solid fa-magnifying-glass"></i><span>Show Source</span>
              </div>
              <div class="menu-item" *ngIf="!contextMenuIsLabelCell" (click)="showSourceForCell($event, contextMenuRow, contextMenuObjectIndex)">
                <i class="fa-solid fa-magnifying-glass"></i><span>Show Source</span>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!contextMenuIsLabelCell">
            <div class="menu-item" *ngIf="!!contextMenuRow.cells[contextMenuObjectIndex].sourceComments && !!contextMenuRow.cells[contextMenuObjectIndex].sourceComments.length" (click)="showComment($event, contextMenuRow, contextMenuRow.cells[contextMenuObjectIndex])">
              <i class="fa-solid fa-message"></i><span>View Comment</span>
            </div>
            <div class="menu-item" *ngIf="!contextMenuRow.cells[contextMenuObjectIndex].sourceComments || !contextMenuRow.cells[contextMenuObjectIndex].sourceComments.length" (click)="openCommentModal(contextMenuRow, contextMenuRow.cells[contextMenuObjectIndex])">
              <i class="fa-solid fa-message"></i><span>Add Comment to Cell</span>
            </div>
          </ng-container>
          <div class="menu-divider"></div>
          <div class="menu-col-heading">Additional Actions</div>
          <div class="menu-item menu-item--multiline" *ngIf="enableAccessToDoc" (click)="openMergeTablesInterface()">
            <i class="fa-solid fa-table-cells-large"></i>
            <div class="menu-item-body">
              <div class="menu-item-title">Insert New Table</div>
              <div class="menu-item-desc">Break this item out or insert supplemental data from the source document</div>
            </div>
          </div>
          <div class="menu-item menu-item--multiline" *ngIf="enableAccessToDoc" (click)="openManageFootnotesInterface()">
            <i class="fa-solid fa-link"></i>
            <div class="menu-item-body">
              <div class="menu-item-title">Link Row to Footnote ({{contextMenuRow?.footnotes?.length || 0}})</div>
              <div class="menu-item-desc">Associate this item to a section in the source document</div>
            </div>
          </div>
        </div>
      </div>
    </li>
    <ng-container *ngIf="contextMenuMode === 'sourceCell'">
      <li (click)="editCellAndStopEvent($event, contextMenuRow, contextMenuObjectIndex)">
        <span>Edit Cell
          <span class="keyboard-shortcuts"><kbd>F2</kbd></span>
        </span>
      </li>
      <li *ngIf="showSourceEnabledInContextMenu && contextMenuRow.itemClass!=='supplementalItem'" (click)="showSourceForCell($event, contextMenuRow, contextMenuObjectIndex)">
        <span>Show Source</span>
      </li>
      <li *ngIf="!!contextMenuRow.cells[contextMenuObjectIndex].sourceComments && !!contextMenuRow.cells[contextMenuObjectIndex].sourceComments.length">
        <span (click)="showComment($event, contextMenuRow, contextMenuRow.cells[contextMenuObjectIndex])">
            View Comment
        </span>
      </li>
      <li *ngIf="!contextMenuRow.cells[contextMenuObjectIndex].sourceComments || !contextMenuRow.cells[contextMenuObjectIndex].sourceComments.length">
        <span (click)="openCommentModal(contextMenuRow, contextMenuRow.cells[contextMenuObjectIndex])">
            Add Comment
        </span>
      </li>
      <li *ngIf="contextMenuRow.categorizedTo && contextMenuRow.itemClass!=='supplementalItem'" (click)="clearedCategorization(contextMenuRow)">
        <span>Uncategorize Row</span>
      </li>
    </ng-container>
    <ng-container *ngIf="contextMenuMode === 'sourceLabel'">
      <li *ngIf="!state.isDerivedOffsetRow(contextMenuRow) && contextMenuRow.itemClass !== 'supplementalItem'" (click)="editLabelAndStopEvent($event, contextMenuRow)">
        <span>Edit Cell</span>
      </li>
      <li *ngIf="showSourceEnabledInContextMenu && contextMenuRow.itemClass!=='supplementalItem'" (click)="showSourceForRow($event, contextMenuRow)">
        <span>Show Source</span>
      </li>
      <li *ngIf="contextMenuRow.categorizedTo && contextMenuRow.itemClass!=='supplementalItem'" (click)="clearedCategorization(contextMenuRow)">
        <span>Uncategorize Row</span>
      </li>
      <li *ngIf="canShowTemplateInvertMenuItem(contextMenuRow)" (click)="invertContextMenuRow()">
        <span>Invert Row Values</span>
      </li>
    </ng-container>
    <ng-container *ngIf="contextMenuMode === 'dasCell' || contextMenuMode === 'sourceCellViewComment' || contextMenuMode === 'derivedOffsetRow'">
        <li *ngIf="!contextMenuRow.cells[contextMenuObjectIndex].sourceComments || !contextMenuRow.cells[contextMenuObjectIndex].sourceComments.length">
            <span (click)="openCommentModal(contextMenuRow, contextMenuRow.cells[contextMenuObjectIndex])">
                Add Comment
            </span>
        </li>
        <li *ngIf="!!contextMenuRow.cells[contextMenuObjectIndex].sourceComments && !!contextMenuRow.cells[contextMenuObjectIndex].sourceComments.length">
            <app-comment-container
                [commentText]="contextMenuRow.cells[contextMenuObjectIndex].sourceComments[0].comment"
                (editContent)="openCommentModal(contextMenuRow, contextMenuRow.cells[contextMenuObjectIndex], true)"
                (deleteContent)="openCommentDeleteModal(contextMenuRow, contextMenuRow.cells[contextMenuObjectIndex])"
            ></app-comment-container>
        </li>
    </ng-container>
    <ng-container *ngIf="contextMenuMode === 'statementDate'">
        <li *ngIf="!isVendorData" (click)="deleteColumn(contextMenuObjectIndex)"><span>Delete Column</span></li>
        <li *ngIf="!isDASStatement && !isVendorData" (click)="addColumnAtIdx(contextMenuObjectIndex)"><span>Add Column to Left</span></li>
        <li *ngIf="!isDASStatement && !isVendorData" (click)="addColumnAtIdx(contextMenuObjectIndex + 1)"><span>Add Column to Right</span></li>
        <li *ngIf="!hasComment(contextMenuColumn)">
            <span (click)="openStatementDateCommentModal(null, contextMenuColumn)">
                Add Comment
            </span>
        </li>
        <li *ngIf="hasComment(contextMenuColumn)">
            <span (click)="showColumnComment($event)">
                View Comment
            </span>
        </li>
    </ng-container>
    <ng-container *ngIf="contextMenuMode === 'statementDateViewComment'">
        <li>
            <app-comment-container
                [commentText]="contextMenuColumn.sourceComments[0].comment"
                (editContent)="openStatementDateCommentModal(null, contextMenuColumn, true)"
                (deleteContent)="openStatementDateCommentDeleteModal(contextMenuColumn)"
            ></app-comment-container>
        </li>
    </ng-container>
    <ng-container *ngIf="contextMenuMode === 'previousPeriodViewCommentMenu'">
        <li>
            <span (click)="showPreviousPeriodComment($event)">
                View Comment
            </span>
        </li>
    </ng-container>
    <ng-container *ngIf="contextMenuMode === 'previousPeriodViewComment'">
        <li>
            <app-comment-container
                [commentText]="contextMenuReadonlyCommentText"
                [readOnly]="true"
            ></app-comment-container>
        </li>
    </ng-container>
  </ul>
  <div
    class="data-container spread-workspace"
    [ngClass]="{
      'spread-workspace--has-left-pane':!isDASStatement
    }"
  >
    <div
      *ngIf="!isDASStatement"
      id="template"
      class="template-container spread-pane"
    >
      <app-spreading-template-table-view
              appGridNav
              [state]="state"
              [editingRowLabelIndex]="editingRowLabelIndex"
              [labelEditFocusPane]="labelEditFocusPane"
              [viewInNativeLanguage]="viewInNativeLanguage"
              [isDASStatement]="isDASStatement"
              [canCategorize]="canCategorize"
              [cellEditFocusPane]="cellEditFocusPane"
              [templateName]="templateName"
              [enableGoalSeek]="enableGoalSeek"
              [visibleSuggestionsOriginId]="visibleSuggestionsOriginId"
              [visibleSuggestionsOriginColIdx]="visibleSuggestionsOriginColIdx"
              [changeTemplateActionIsVisible]="!isTemplateChooserDisabled && availableTemplates.length > 1 && state.documentFile.initialTemplateSelectionHasBeenMade && !isVendorData"
              (goalSeek)="goalSeek($event)"
              (hideSuggestions)="hideSuggestions()"
              (clearedCategorization)="clearedCategorization($event)"
              (stateChanged)="onSpreadingTemplatePanelStateChanged($event)"
              (manualSourceRowInserted)="scrollManualSourceRowIntoView($event)"
              (sourceRowLabelChanged)="onTemplateSourceRowLabelChanged($event)"
              (sourceRowLabelEditStart)="onTemplateSourceRowLabelEditStart($event)"
              (sourceRowLabelClick)="onTemplateSourceRowLabelClick($event)"
              (sourceRowCellValueChanged)="onTemplateSourceRowCellValueChanged($event)"
              (sourceRowCellEditStart)="onTemplateSourceRowCellEditStart($event)"
              (sourceRowCellSelect)="onTemplateSourceRowCellSelect($event)"
              (sourceRowCellContextMenu)="onTemplateSourceRowCellContextMenu($event)"
              (sourceRowLabelContextMenu)="onTemplateSourceRowLabelContextMenu($event)"
              (invertRow)="onTemplateInvertRow($event)"
              (sourceRowCellValueBeforeEdit)="handleValue($event)"
              (sourceRowCellKeyDown)="onTemplateSourceRowCellKeyDown($event)"
              (cellBlur)="clearCellSelectionHighlight()"
              (previousPeriodCellViewComment)="onPreviousPeriodCellViewComment($event)"
              (previousPeriodColumnViewComment)="onPreviousPeriodColumnViewComment($event)"
              (changeTemplateClick)="showSpreadingTemplateSelectionPopup()"
      ></app-spreading-template-table-view>
    </div>

    <!-- Collapsible middle: shrinks to 0 before template/source panes lose width (unlike CSS gap) -->
    <div
      class="spread-workspace-spacer"
      *ngIf="!isDASStatement && state.sourceRows.length"
      aria-hidden="true"
    ></div>

    <div
      id="src-container"
      *ngIf="state.sourceRows.length"
      class="source-container spread-pane src-container-scroll"
      appGridNav
    >
      <div class="src-table-scroll-wrapper" appRowLinkHover>
      <table [ngClass]="{
        'spread-source-table--compact': !isDASStatement,
        'das-source-table': isDASStatement
      }">
        <thead class="sticky">
          <tr class="date-header-row">
            <th *ngIf="isDASStatement" class="cat-header "></th>
            <th *ngIf="isDASStatement" class="cat-header categorization-td include-exclude-cell"></th>
            <th class="cat-header  line-item-td"></th>
            <ng-container *ngIf="isDASStatement">
              <th class="date-header previous-period-header das-selected"
                *ngFor="let pcol of state.previousPeriodColumns"
              >
                <span class="previous-period-indicator"
                      title="This data is from a previously completed spread and cannot be edited here.">
                  <i class="fa fa-clock-rotate-left"></i>
                </span>
                <i *ngIf="hasPreviousPeriodColumnComment(pcol)"
                   class="fas fa-comment fa-flip-horizontal header-comment"
                   title="This period has a comment on it."></i>
                <i *ngIf="hasPreviousPeriodColumnComment(pcol)"
                   class="fas fa-ellipsis-vertical previous-period-comment-menu"
                   (click)="onPreviousPeriodColumnViewComment({event: $event, column: pcol})"
                   title="More actions"></i>
                <span>{{pcol.statementDate}}</span>
              </th>
            </ng-container>
            <!-- Editing is owned by the cell, not by the value: the date editor is
                 sized to its own text, so a column with no date offers nothing to click. -->
            <th class="date-header"
              *ngFor="let column of state.columns; let colIdx=index"
              [ngClass]="{
                'first-header-column': colIdx === 0,
                'projection': isProjectionOrProforma(column.scenario)
              }"
              [class.das-selected]="isDASStatement"
              (contextmenu)="rightClickedStatementDate($event, colIdx, column)"
              (dblclick)="!isDASStatement && !isVendorData && editColumnHeader(colIdx, 'statementDate')"
            >

              <div class="date-header-content">
                <div class="column-menu-toggle"
                  (click)="rightClickedStatementDate($event, colIdx, column);"
                  (dblclick)="$event.stopPropagation()">
                  <i class="column-menu-toggle-icon fas fa-chevron-down fa-xs"></i>
                </div>
                <div class="date-header-content__end">
                  <i *ngIf="willColumnOverwrite(column) && !isDASStatement"
                    class="fas fa-triangle-exclamation header-overwrite-warning" 
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Overwrites previous period"
                  ></i>
                  <i *ngIf="hasComment(column)" class="fas fa-comment fa-flip-horizontal header-comment"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="This period has a comment on it."
                  ></i>
                  <app-double-click-to-edit
                    *ngIf="!isDASStatement && !isVendorData; else readOnlyStatementDate"
                    class="date-header-value"
                    [value]="column.statementDate"
                    mask="__/__/____"
                    [alignRight]="true"
                    [editing]="editingColumnHeaderIndex == colIdx && editingColumnHeader == 'statementDate'"
                    (changed)="columnHeaderChanged($event, column, 'statementDate')"
                    (enteredEditMode)="editColumnHeader(colIdx, 'statementDate')"
                  >
                  </app-double-click-to-edit>
                  <ng-template #readOnlyStatementDate>
                    <span class="date-header-value">{{column.statementDate}}</span>
                  </ng-template>
                </div>
              </div>
            </th>
          </tr>
          <tr class="sub-header-row">
            <th *ngIf="isDASStatement" class="cat-header "></th>
            <th *ngIf="isDASStatement" class="cat-header categorization-td include-exclude-cell"></th>
            <th class="header-row-title"></th>
            <ng-container *ngIf="isDASStatement">
              <th class="th reporting-interval-header previous-period-header das-selected"
                *ngFor="let pcol of state.previousPeriodColumns"
              >
                <span>{{pcol.reportingInterval}}</span>
              </th>
            </ng-container>
            <th class="th reporting-interval-header"
              *ngFor="let column of state.columns; let colIdx=index"
              [ngClass]="{
                'first-header-column': colIdx === 0,
                'projection': isProjectionOrProforma(column.scenario)
              }"
              [class.das-selected]="isDASStatement"
            >
              <select class="inline-edit right"
                      *ngIf="!isDASStatement && !isVendorData; else readOnlyInterval"
                      [(ngModel)]="column.reportingInterval"
                      (change)="columnHeaderDropDownChanged()"
              >
                <option value="MONTHLY">Monthly</option>
                <option value="QUARTERLY">Quarterly</option>
                <option value="SEMI_ANNUALLY">Semi-annual</option>
                <option value="ANNUALLY">Annual</option>
                <option value="FISCAL_YTD">Fiscal YTD</option>
              </select>
                <ng-template #readOnlyInterval>
                    <span>{{column.reportingInterval}}</span>
                </ng-template>
            </th>
          </tr>
          <tr class="sub-header-row">
              <th *ngIf="isDASStatement" class="cat-header "></th>
              <th *ngIf="isDASStatement" class="cat-header categorization-td include-exclude-cell"></th>
              <th class="header-row-title"></th>
              <ng-container *ngIf="isDASStatement">
                <th class="th prep-type-header previous-period-header das-selected"
                  *ngFor="let pcol of state.previousPeriodColumns"
                >
                  <span>{{pcol.scenario}}</span>
                </th>
              </ng-container>
              <th class="th prep-type-header"
                  *ngFor="let column of state.columns; let colIdx=index"
                  [ngClass]="{
                'first-header-column': colIdx === 0,
                'projection': isProjectionOrProforma(column.scenario),
                'projection-selected': column.scenario === scenarioTypeProjection
              }"
              [class.das-selected]="isDASStatement"
              >
                <!-- Edit projection name icon for dropdown scenario - only show for projection scenarios -->
                <span *ngIf="!isDASStatement && column.scenario === 'PROJECTION'"
                  class="projection-edit-icon"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Edit Projection Name"
                  (click)="openEditProjectionNameModal(column)"
                  tabindex="0"
                  aria-label="Edit Projection Name">
                  <i class="fas fa-pencil-alt"></i>
                </span>
                 <select class="inline-edit right"
                       *ngIf="!isDASStatement && !isVendorData; else readOnlyScenario"
                         [(ngModel)]="column.scenario"
                         (change)="columnHeaderDropDownChanged()"
                 >
                     <option value="HISTORICAL">Historical</option>
                     <option value="PROJECTION">Projection</option>
                 </select>
                  <ng-template #readOnlyScenario>
                    <!-- Edit projection name icon - only show for projection scenarios -->
                    <span *ngIf="column.scenario === 'PROJECTION'"
                      class="projection-edit-icon"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Edit Projection Name"
                      (click)="openEditProjectionNameModal(column)"
                      tabindex="0"
                      aria-label="Edit Projection Name">
                      <i class="fas fa-pencil-alt"></i>
                    </span>
                    <span>{{column.scenario}}</span>
                  </ng-template>
              </th>
          </tr>
          <tr class="sub-header-row" [class.last-das-header-row]="isDASStatement">
            <th *ngIf="isDASStatement" class="cat-header "></th>
            <th *ngIf="isDASStatement" class="cat-header categorization-td include-exclude-cell"></th>
            <th *ngIf="isDASStatement" class="header-row-title"></th>
            <th *ngIf="!isDASStatement" class="header-row-title">
                <div class="categorized-count-container">
                    <div class="categorized-count">{{ countOfUncategorizedLineItems }} not categorized</div>
                    <div class="show-hide-categorized">
                        <div>Hide categorized</div>
                        <i class="fas fa-toggle-off show-categorization-toggle-icon" (click)="toggleHideCategorizedDocumentRows($event)"
                           [ngClass]="{'fa-toggle-off': !hideCategorizedDocumentItems, 'fa-toggle-on': hideCategorizedDocumentItems, 'disabled': reSpreadInProgress}"></i>
                    </div>
                </div>
            </th>
            <ng-container *ngIf="isDASStatement">
              <th class="prep-type-header previous-period-header das-selected"
                *ngFor="let pcol of state.previousPeriodColumns"
              >
                <span>{{pcol.preparationType}}</span>
              </th>
            </ng-container>
            <th class="prep-type-header"
              *ngFor="let column of state.columns; let colIdx=index"
              [ngClass]="{
                'first-header-column': colIdx === 0,
                'projection': isProjectionOrProforma(column.scenario)
              }"
              [class.das-selected]="isDASStatement"
            >
            <ng-container *ngIf="!isDASStatement; else readOnlyPreparationType">
              <select *ngIf="column.scenario !== scenarioTypeProjection"
                      class="inline-edit right"
                      [(ngModel)]="column.preparationType"
                      (change)="columnHeaderDropDownChanged()"
              >
                <option value="UNKNOWN">Unknown</option>
                <option value="UNQUALIFIED">Unqualified</option>
                <option value="QUALIFIED">Qualified</option>
                <option value="TAX_RETURN">Tax Return</option>
                <option value="REVIEWED">Reviewed</option>
                <option value="CPA_PREP">CPA Prepared</option>
                <option value="NTR">NTR</option>
                <option value="MANAGEMENT">Management</option>
              </select>
              <select *ngIf="column.scenario === scenarioTypeProjection"
                      class="inline-edit right"
                      [(ngModel)]="column.preparationType"
                      (change)="columnHeaderDropDownChanged()"
              >
                <option value="MANAGEMENT">Management</option>
                <option value="CPA_PREP">CPA Prepared</option>
                <option value="ANALYST">Analyst</option>
              </select>
            </ng-container>
                 <ng-template #readOnlyPreparationType>
                    <span>{{column.preparationType}}</span>
                </ng-template>
            </th>
          </tr>
          <ng-container *ngIf="!isDASStatement">
              <tr class="reference-row" *ngFor="let row of state.referenceRows; let rowIdx = index">
                <td
                    class=" line-item-td"
                    [ngClass]="{
                    'last-reference-row': rowIdx === state.referenceRows.length - 1
                  }"
                >{{row.label}}</td>
                <td *ngFor="let cell of row.cells; let cellIdx = index"
                  class="reference-row-value"
                  [ngClass]="{
                    'last-reference-row': rowIdx === state.referenceRows.length - 1
                  }"
                  [class.das-selected]="isDASStatement"
                >
                  {{getRoundedValue(cell.value, row) | number:'1.2-2'}}
                </td>
              </tr>
          </ng-container>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of state.sourceRows; let idx = index">
          <tr
          (mousedown)="onRowMouseDown($event, idx, row)"
          (click)="selectRow($event, idx, row)"
          [attr.data-source-row-uuid]="row.uuid"
          [attr.data-row-key]="row.uuid"
          [ngClass]="{
            'selected': row.selected,
            'mapped': isSourceRowLinkedToTemplate(row),
            'unlabeled': !row.categorizedTo && row.label == UNLABELED_ROW_PREFIX,
            'header': row.header,
            'display-bold': row.displayBold,
            'editing-disabled': !row.displayBold && isCellEditingDisabled(row),
            'hidden': hideCategorizedDocumentItems && isSourceRowLinkedToTemplate(row)
          }"
        >
          <td *ngIf="isDASStatement" class="weight-adjustment-cell">
              <div class="input-group"
                   *ngIf="row.itemClass === 'AdjustedStandardItem' || row.itemClass === 'NonAdjustableStandardItem'"
                   >

                  <input class="form-control weight-input-control"
                         type="text"
                         [class.is-invalid]="percent?.errors?.pattern"
                         #percent="ngModel"
                         name="percent{{idx}}"
                         pattern="[0-9]+(\.[0-9]+)?"
                         [(ngModel)]="row.weightPercentage"
                         [disabled]="row.itemClass === 'NonAdjustableStandardItem'"
                         (change)="weightInputChange(row)"
                         >

                  <div class="input-group-append weight-input-control-append">
                      <span class="input-group-text" >%</span>
                  </div>

                  <span class="invalid-feedback"
                        *ngIf="percent?.errors?.pattern">
                      Please enter a valid numerical value.
                  </span>
              </div>
          </td>
          <td *ngIf="isDASStatement" class="include-exclude-cell" (contextmenu)="rightClickedRow($event, idx, row)">
              <ng-container *ngIf="row.itemClass === 'AdjustedStandardItem' || row.itemClass === 'NonAdjustableStandardItem' || row.isExcludableInOtherCalculations">
                  <input type="checkbox"
                         [id]="row.lineItemId"
                         class="form-check-input"
                         [(ngModel)]="row.include"
                         [disabled]="row.itemClass === 'NonAdjustableStandardItem'"
                         (change)="toggleIncludeItem(row)"
                         [class.weight]="row.itemClass === 'AdjustedStandardItem' || row.itemClass === 'NonAdjustableStandardItem'"
                         title="Include or exclude this item from calculations."
                        >
                  <label class="form-check-label ps-2"
                         [for]="row.lineItemId"
                         [class.weight]="row.itemClass === 'AdjustedStandardItem' || row.itemClass === 'NonAdjustableStandardItem'"
                         >
                      Include
                  </label>
              </ng-container>
          </td>
          <td class=" line-item-td" (contextmenu)="rightClickedSourceLabel($event, idx, row)"
              [class.translated-label-cell]="!viewInNativeLanguage && rowHasTranslation(row)"
              [class.label-cell-selected]="row.labelSelected"
              [class.grid-nav-cell]="!row.header"
              [attr.tabindex]="row.header ? null : 0"
              (focus)="selectLabel(row)"
              (blur)="releaseCellHighlight($event)"
              (keydown)="onSourceLabelKeydown(row, idx, $event)" appFsMask>
            <div [className]="'indent indent-' + row.indentation"></div>
            <div class="line-item"
            [class.percent-padding]="row.itemClass === 'AdjustedStandardItem' || row.itemClass === 'NonAdjustableStandardItem'"
            [class.editing]="editingRowLabelIndex == idx && labelEditFocusPane === 'source'"
            [ngClass]="{
              'calculated': row.calculated,
              'suggested': row.suggestedChange,
            }"
            (click)="clickLineItemLabel(row, $event)">
              <app-double-click-to-edit
                [value]="row.userFacingLabel ? row.userFacingLabel : ((viewInNativeLanguage) ? row.label : (row.translatedLabel || row.label))"
                (changed)="rowLabelChanged($event, row)"
                (enteredEditMode)="handleEditSourceRowLabel(idx, row?.itemClass)"
                [editing]="editingRowLabelIndex == idx && labelEditFocusPane === 'source'"
                [isEditingDisabled]="isSourceRowLabelEditDisabled(row)"
                [footnotePresent]="!!row?.footnotes?.length"
                [isUserAddedRow]="row?.isUserAddedRow"
              ></app-double-click-to-edit>
              <div *ngIf="!isDASStatement && !row.header"
                 class="fas fa-ellipsis-vertical line-item-kebab-menu"
                 (click)="rightClickedSourceLabel($event, idx, row); $event.stopPropagation()"
                 (contextmenu)="rightClickedSourceLabel($event, idx, row); $event.stopPropagation()"
                 title="More actions"></div>
              <button type="button" class="line-item-invert-icon" *ngIf="canShowInvertIcon(row)"
                      [class.inverted]="row.invertValue"
                      [appBsTooltip]="getInvertTooltip(row)"
                      aria-label="Invert row values"
                      [attr.aria-pressed]="!!row.invertValue"
                      (click)="invertRow(row, $event)">
                <i class="fa-solid fa-plus-minus"></i>
              </button>
              <span *ngIf="!isDASStatement && isSourceRowLinkedToTemplate(row)" class="categorization-indicator-wrap"
                    (mouseenter)="positionCategorizationFlyout($event)">
                <i *ngIf="row.categorizationType === 'component'"
                   class="fa-regular fa-circle-check categorization-indicator categorization-indicator--component"
                   aria-label="Categorized (Component)"></i>
                <span *ngIf="row.categorizationType === 'validation'"
                      class="categorization-indicator categorization-indicator--validation"
                      aria-label="Categorized (Validation)">V</span>
                <span class="categorization-flyout" (click)="$event.stopPropagation()">
                  <span class="categorization-flyout__label">{{ row.categorizationType === 'validation' ? 'Validated to: ' : 'Categorized to: ' }}{{ row.categorizationLabel }}</span>
                  <button type="button" class="btn categorization-flyout__view" (click)="viewCategorizationTarget(row, $event)">View →</button>
                </span>
              </span>
              <span *ngIf="!isDASStatement && !isSourceRowLinkedToTemplate(row)" class="categorization-indicator-placeholder"></span>
            </div>

            <div class="goalSeekTooltip" *ngIf="row.suggestedChange && visibleSuggestionsOriginId && row.suggestionOrigin === visibleSuggestionsOriginId" (click)="removeSuggestionFromRow($event, row)">
              {{ row.suggestedChange }}
            </div>
          </td>
          <ng-container *ngIf="isDASStatement">
            <td *ngFor="let pcol of state.previousPeriodColumns; let pIdx = index"
                class="previous-period-cell das-selected"
            >
              <ng-container *ngIf="!row.header">
                <ng-container *ngTemplateOutlet="dasPreviousPeriodCell; context: {row: row, pIdx: pIdx}"></ng-container>
              </ng-container>
            </td>
          </ng-container>
          <td
            *ngFor="let cell of row.cells; let cellIdx = index"
            class="no-padding"
            [class.grid-nav-cell]="!row.header"
            [attr.tabindex]="row.header ? null : 0"
            (focus)="onSourceCellFocus(row, cellIdx, idx)"
            (blur)="releaseCellHighlight($event)"
            (keydown)="onSourceCellKeydown(row, cellIdx, $event)"
            [ngClass]="{
              'das-selected': isDASStatement,
              'selected-celll': row.cellSelectedIndex === cellIdx
            }"
          >
            <div class="outer-height"
            [ngClass]="{
              'unselected-cell':row.cellSelectedIndex !== cellIdx,
              'percent-padding':row.itemClass === 'AdjustedStandardItem' || row.itemClass === 'NonAdjustableStandardItem'
            }"
            >
              <app-statement-table-cell *ngIf="!row.header"
                [cellForSourceComments]="cell"
                [value]="cell.roundedRawText"
                [confidence]="cell.confidence"
                (rerenderEvent)="_crd.detectChanges()"
                (cellValueChanged)="doneEditingCell($event, row, cellIdx)"
                (enteredEditMode)="editCell(row, cellIdx)"
                [isEditing]="row.cellEditingIndex === cellIdx && cellEditFocusPane === 'source'"
                [isEditingDisabled]="isCellEditingDisabled(row)"
                [isSelected]="row.cellSelectedIndex === cellIdx"
                [isNumeric]="cellShouldAlignRight(cell)"
                [textFormat]="row.textFormat"
                [reverseDisplaySign]="row.invertValue"
                (cellSelected)="highlightCell(row, cellIdx, idx, $event)"
                (click)="highlightCell(row, cellIdx, idx, $event)"
                (rightClickedOnCell)="rightClickedSourceCell($event, row, cell, cellIdx, idx)"
                (valueBeforeEditsMade)="handleValue($event)"
                (keydown)="handleKeyDown(cell, $event)"
              ></app-statement-table-cell>
            </div>
          </td>
          </tr>
          <ng-container *ngIf="isDASStatement">
            <ng-container *ngFor="let prevOnlyRow of state.dasPreviousOnlyRowsByAnchor[row.uuid]">
              <ng-container *ngTemplateOutlet="dasPreviousOnlyRow; context: {row: prevOnlyRow}"></ng-container>
            </ng-container>
          </ng-container>
          </ng-container>
        </tbody>
      </table>

      <!-- Read-only cell content for a previous-period column in the DAS Document Details table. -->
      <ng-template #dasPreviousPeriodCell let-row="row" let-pIdx="pIdx">
        <div class="previous-period-cell-content">
          <i *ngIf="dasPreviousPeriodCellHasMismatch(row, pIdx)"
             class="fas fa-triangle-exclamation previous-period-mismatch-icon"
             [title]="dasPreviousPeriodCellTooltip(row, pIdx)"></i>
          <i *ngIf="hasPreviousPeriodCellComment(row, pIdx)"
             class="fas fa-ellipsis-vertical previous-period-comment-menu"
             (click)="onPreviousPeriodCellViewComment({event: $event, cell: row.previousCells[pIdx]})"
             title="More actions"></i>
          <app-comment-present-indicator
            *ngIf="hasPreviousPeriodCellComment(row, pIdx)"
            [sourceComments]="row.previousCells[pIdx]?.sourceComments"
          ></app-comment-present-indicator>
          <ng-container *ngIf="previousPeriodCellDisplay(row, pIdx) as d; else dasPrevCellMissing">
            <span class="data-cell-text">{{ d.rounded | number:'1.2-2' }}</span>
          </ng-container>
          <ng-template #dasPrevCellMissing>
            <span class="previous-period-missing"
                  title="This item does not exist in the previous spread.">-</span>
          </ng-template>
        </div>
      </ng-template>

      <!-- Synthetic read-only row for a prior DAS item with no current-spread match. -->
      <ng-template #dasPreviousOnlyRow let-row="row">
        <tr class="das-previous-only-row editing-disabled"
            [attr.data-source-row-uuid]="row.uuid"
            [attr.data-row-key]="row.uuid"
        >
          <td class="weight-adjustment-cell"></td>
          <td class="include-exclude-cell"></td>
          <td class="line-item-td">
            <div [className]="'indent indent-' + row.indentation"></div>
            <div class="line-item">
              <span class="previous-only-label">{{ row.label }}</span>
              <i class="fas fa-lock previous-only-lock-icon"
                 title="This item is from a previous spread and cannot be edited here."></i>
            </div>
          </td>
          <td *ngFor="let pcol of state.previousPeriodColumns; let pIdx = index"
              class="previous-period-cell das-selected"
          >
            <ng-container *ngTemplateOutlet="dasPreviousPeriodCell; context: {row: row, pIdx: pIdx}"></ng-container>
          </td>
          <td *ngFor="let cell of row.cells" class="das-selected previous-only-current-cell">
            <span class="previous-period-missing"
                  title="This item does not exist in the current spread.">-</span>
          </td>
        </tr>
      </ng-template>
      <div
        *ngIf="!isDASStatement && sourceRowWithOpenMappingBox as mapRow"
        id="mappingAutocompleteContainer"
        class="source-categorization-flyout"
        (click)="stopPropagation($event)"
      >
        <div class="autocomplete-wrapper" [ngClass]="{ validation: mapRow.mappingBoxValidation }">
          <ng-select
            class="custom autocomplete"
            [items]="getAutocompleteOptionsForRow(mapRow)"
            bindLabel="value"
            bindValue="id"
            autofocus
            (change)="rowMapped($event, mapRow)"
            (keydown)="handleCategorizationDropdownEscape($event, mapRow)"
            [markFirst]="true"
            minTermLength="1"
            [dropdownPosition]="getAutocompleteOptionsForRow(mapRow).length <= 1 ? 'top' : 'auto'"
          >
          </ng-select>
        </div>
      </div>
      </div>
    </div>
    <div
      class="spread-workspace-spacer"
      *ngIf="isDASStatement && state.sourceRows.length && state.templateHasSubmissionRules && submissionRulesSidebarIsOpen"
      aria-hidden="true"
    ></div>

    <div class="empty spread-workspace-placeholder" *ngIf="!state.sourceRows.length">
      <i class="far fa-file"></i>
      <h1>No source data</h1>
    </div>

    <div
      class="document-view-overlay"
      *ngIf="documentSidebarIsOpen && !isVendorData"
      [style.width.%]="docPaneWidthPercent"
    >
      <div
        class="spread-doc-resize-handle"
        [ngClass]="{ 'is-resizing': isResizingDocSplit }"
        (mousedown)="resizeDocSplitMouseDown($event)"
      ></div>
      <div class="document-view-overlay__inner">
        <app-document-view-split-screen
          [pageImgUrls]="state.documentFile.pageImageUrls"
          [originalFileUrl]="originalDocumentFileUrl"
          [documentFileId]="state?.documentFile?.id || fileId"
          [documentFileType]="state.documentFile.fileType"
          [viewSourceBox]="viewSourceBox"
          [viewSourcePage]="viewSourcePage"
          (closeSplitscreen)="closeDocumentExplorer()"
          (rerenderEvent)="_crd.detectChanges()"
        ></app-document-view-split-screen>
      </div>
    </div>

    <div class="template-container spread-pane submission-rules-pane" *ngIf="isDASStatement && state.templateHasSubmissionRules && submissionRulesSidebarIsOpen">
        <app-das-submission-rule-results-summary
            [ruleResultsSummary]="state.submissionRuleResultsSummary"
            [hasSubmissionRuleResults]="state.hasSubmissionRuleResults"
        ></app-das-submission-rule-results-summary>
    </div>

    <app-previous-periods-filter-panel
      *ngIf="previousPeriodsFilterPanelOpen"
      [availablePeriods]="state?.availablePreviousPeriods || []"
      [selectedKeys]="state?.selectedPreviousPeriodKeys || []"
      [triggerEl]="filterPeriodsTrigger"
      (applyFilters)="onPreviousPeriodSelectionChanged($event); closePreviousPeriodsFilterPanel()"
      (closePanel)="closePreviousPeriodsFilterPanel()"
    ></app-previous-periods-filter-panel>
  </div>
  <app-ai-disclaimer-banner [flagKey]="llmAutonormFlag"></app-ai-disclaimer-banner>
  <div class="tabs">
      <ng-container *ngFor="let statement of relatedStatements">
          <button *ngIf="statement.id !== state.statement.id; else currentStatementTab"
                  (click)="switchToStatement(statement)"
                  [ngClass]="{
        'hard-stop': state.templateHasSubmissionRules && validationSubmissionRuleService.submissionRuleTabStatusSummary[statement.id] === SubmissionRuleActions.HARD_STOP,
        'soft-stop': state.templateHasSubmissionRules && validationSubmissionRuleService.submissionRuleTabStatusSummary[statement.id] === SubmissionRuleActions.SOFT_STOP,
        'passing-all-rules': state.templateHasSubmissionRules && validationSubmissionRuleService.submissionRuleTabStatusSummary[statement.id] === 'PASSING'
        
      }"
          ><i *ngIf="state.templateHasSubmissionRules" class="fa pe-2" [ngClass]="{
            'fa-circle-xmark': validationSubmissionRuleService.submissionRuleTabStatusSummary[statement.id] === SubmissionRuleActions.HARD_STOP,
            'fa-triangle-exclamation': validationSubmissionRuleService.submissionRuleTabStatusSummary[statement.id] === SubmissionRuleActions.SOFT_STOP,
            'fa-check-circle': validationSubmissionRuleService.submissionRuleTabStatusSummary[statement.id] === 'PASSING',
        }"></i> {{ statement.statementType === DYNAMIC_ADJUSTMENT_STATEMENT && statement?.uniqueDasName ? statement.uniqueDasName : statement.statementType | docType | titlecase }}
          </button>
          <ng-template #currentStatementTab>
              <button (click)="switchToStatement(statement)" class="active"
                      [ngClass]="{
        'hard-stop': state.templateHasSubmissionRules && state.submissionRuleResultsStatementLevelStatus === SubmissionRuleActions.HARD_STOP,
        'soft-stop': state.templateHasSubmissionRules && state.submissionRuleResultsStatementLevelStatus === SubmissionRuleActions.SOFT_STOP,
        'passing-all-rules': state.templateHasSubmissionRules && state.submissionRuleResultsStatementLevelStatus === 'PASSING'
      }"
              ><i *ngIf="state.templateHasSubmissionRules" class="fa pe-2" [ngClass]="{
            'fa-circle-xmark': state.submissionRuleResultsStatementLevelStatus === SubmissionRuleActions.HARD_STOP,
            'fa-triangle-exclamation': state.submissionRuleResultsStatementLevelStatus === SubmissionRuleActions.SOFT_STOP,
            'fa-check-circle': state.submissionRuleResultsStatementLevelStatus === 'PASSING',
        }"></i> {{ statement.statementType === DYNAMIC_ADJUSTMENT_STATEMENT && statement?.uniqueDasName ? statement.uniqueDasName : statement.statementType | docType | titlecase }}
              </button>
          </ng-template>
      </ng-container>
  </div>
  </ng-template>
</div>
